class LocalStorageService {
  set(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  get(key) {
    const existItem = sessionStorage.getItem(key);

    if (!existItem) { 
      return null 
    }
    
    return JSON.parse(existItem);
  }

  remove(key) {
    sessionStorage.removeItem(key);
  }

  clear() {
    sessionStorage.clear();
  }
}

const instance = new LocalStorageService();
Object.freeze(instance);

export default instance;